import type { core } from 'zod';

import { MultiSelectOption } from '../MultiSelect';

/**
 * Sorts multiselect dropdown options so that selected options are placed on top of unselected ones
 * and the empty value is always placed at the bottom.
 */
export function sortSelected<Data extends core.util.Primitive>(
  a: MultiSelectOption<Data>,
  b: MultiSelectOption<Data>,
  selection: Data[]
) {
  const aSelected = selection.includes(a.value);
  const bSelected = selection.includes(b.value);
  // selected entries should be placed before unselected ones
  if (aSelected && !bSelected) {
    return -1;
  }
  if (!aSelected && bSelected) {
    return 1;
  }
  // ensure the empty value always gets put in last place
  if (a.value === '') {
    return 1;
  }
  if (b.value === '') {
    return -1;
  }

  // keep the original order if option is neither selected nor empty
  return 0;
}
